import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";

import { AudienceExportsList } from "@/features/Audiences/AudienceExports";
import { returnToAudienceSchema } from "@/features/Audiences/return";
import { audienceExportsSearchSchema } from "@/features/Audiences/types";

export const Route = createFileRoute("/_auth/people/$siteId/audiences/exports")(
  {
    validateSearch: (raw) =>
      audienceExportsSearchSchema.and(returnToAudienceSchema).parse(raw),
    component: AudienceExportsPage,
  },
);

function AudienceExportsPage() {
  const { siteId } = useParams({
    from: "/_auth/people/$siteId/audiences/exports",
  });
  const search = useSearch({ from: "/_auth/people/$siteId/audiences/exports" });
  return <AudienceExportsList siteId={siteId} search={search} />;
}
